import { Api } from '@/common/utils';

export const getTask = async (taskId) => {
  const { data } = await Api.request({
    url: `/task/${taskId}`,
  });

  return data;
};

export const updateTaskStatus = async (taskId, status) => {
  await Api.request({
    url: `/task/${taskId}`,
    method: 'put',
    payload: {
      status,
    },
  });

  return { taskId, status };
};

export const updateTaskStep = async (stepId, isDone) => {
  await Api.request({
    url: `/task/step/${stepId}`,
    method: 'put',
    payload: {
      isDone,
    },
  });

  return { stepId, isDone };
};

export const createTaskStepNote = async (stepId, note) => {
  const { data } = await Api.request({
    url: `/task/step/${stepId}/note/create`,
    method: 'post',
    payload: {
      note,
    },
  });

  return data;
};

export const deleteTaskStepNote = async (noteId) => {
  await Api.request({
    url: `/task/step/note/${noteId}`,
    method: 'delete',
  });

  return noteId;
};
